<footer class="relative">
  <img
    class="hidden lg:block w-full bg-white"
    [src]="env.footerComponent.bannerImages.desktop.url"
    [ngStyle]="env.footerComponent.bannerImages.desktop.style"
    [alt]="env.footerComponent.bannerImages.desktop.altText" />
  <img
    class="block lg:hidden w-full bg-white"
    [src]="env.footerComponent.bannerImages.mobile.url"
    [ngStyle]="env.footerComponent.bannerImages.mobile.style"
    [alt]="env.footerComponent.bannerImages.mobile.altText" />
  <section
    class="footer-text w-full bottom-0 flex flex-column lg:flex-row align-items-center px-6 py-6 md:py-5 bg-white"
    [style.color]="env.footerComponent.textColor || '#FFFFFF'"
    [ngStyle]="env.footerComponent.style">
    <p
      class="m-0 font-poppins text-lg md:text-3xl lg:text-lg flex md:align-items-center font-medium mb-3 md:mb-0">
      {{ env.staticTextContents.footerComponent.poweredBy }}
      <span class="ml-1">
        <img
          [src]="env.footerComponent.razorpayLogo.url"
          [ngStyle]="env.footerComponent.razorpayLogo.style"
          alt="Razorpay" />
      </span>
    </p>
    <div
      class="p-1 pl-3 flex flex-wrap justify-content-center align-items-center">
      <p
        class="m-0 text-xs pr-2 white-space-nowrap"
        data-testid="copyright-text">
        © {{ currentYear }}
      </p>
      <visa-platform-common-anchor
        class="flex align-items-center"
        *ngIf="env.footerComponent.privacyPolicyLink"
        [href]="env.footerComponent.privacyPolicyLink"
        [className]="
          'text-xs underline border-left-1 px-2 white-space-nowrap footer-links'
        "
        [color]="env.footerComponent.textColor || '#FFFFFF'"
        [text]="env.staticTextContents.footerComponent.privacyPolicyLabel"
        data-testid="privacy-policy-link"></visa-platform-common-anchor>
      <visa-platform-common-anchor
        class="flex align-items-center"
        *ngIf="env.footerComponent.termsAndConditionsLink"
        [href]="env.footerComponent.termsAndConditionsLink"
        [className]="
          'text-xs underline border-left-1 px-2 white-space-nowrap footer-links'
        "
        [color]="env.footerComponent.textColor || '#FFFFFF'"
        [text]="env.staticTextContents.footerComponent.termsAndConditionsLabel"
        data-testid="terms-link"></visa-platform-common-anchor>
      <visa-platform-common-anchor
        class="flex align-items-center"
        *ngIf="env.footerComponent.faqLink"
        [href]="env.footerComponent.faqLink"
        [className]="
          'text-xs underline border-left-1 px-2 white-space-nowrap footer-links'
        "
        [color]="env.footerComponent.textColor || '#FFFFFF'"
        [text]="env.staticTextContents.footerComponent.faqLabel"
        data-testid="faq-link"></visa-platform-common-anchor>
      <a
        *ngIf="env.footerComponent.emailId"
        [href]="'mailto:' + env.footerComponent.emailId"
        [class]="
          'text-xs underline border-left-1 px-2 white-space-nowrap footer-links mt-2 md:mt-0'
        "
        [style.color]="env.footerComponent.textColor || '#FFFFFF'">
        {{ env.footerComponent.emailId }}
      </a>
    </div>
  </section>
</footer>
